import React, { useContext } from "react";
import { ModalContext } from "../../context/ModalContext";

const ErrorAlert = () => {
  const { showAlert, alertContent, clearAlert } = useContext(ModalContext);

  return (
    <div
      className={`alert alert-danger alert-dismissible fixed-top ms-auto me-2 fade-show ${
        !showAlert ? "hidden" : ""
      }`}
      role="alert"
      style={{
        maxWidth: 500,
        zIndex: 2500,
        // Offset by the device safe area (notch / Dynamic Island) plus a small
        // gap, so the alert never renders under the status bar.
        marginTop: "calc(env(safe-area-inset-top, 0px) + 16px)",
      }}
    >
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-11">{alertContent}</div>
          <div className="col-1 text-end">
            <button className="btn btn-link" onClick={clearAlert}>
              <i className="fa fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorAlert;
